module.exports = "/assets/packs/images/49b2f07f28ac5cb31ab20e8cd068db58.svg";